import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";
// import { Cart_Fragment } from "../fragments/cart";

export const Cart_Query = graphqlShopifyStorefront(
  `
  query Cart($cartId: ID!) {
    cartMasked: cart(id: $cartId) {
      ...Cart
    }
  }
`,
  // [Cart_Fragment],
);
